import Enums from './enums';
import { AppRoles } from './utils';

const UserInfo = {
    userName: null,
    userId: null,
    // Instance name and ID are for the current instance
    instanceName: null,
    instanceId: null,
    // Native instance ID is for the user's native instance (the instance to which they belong to)
    nativeInstanceId: null,
    // Instances are a collection of all instances and the user role for each
    instances: [],
    locations: [],
    roles: [],
    firstName: null,
    lastName: null,
    groupId: null,
    state: null,
    culture: 'en-US',
    weightUnits: 'Kgs',
    onlyLbsDecimal : false,
    fullPayload: null,
    PreferedLeakDetection: null,
    isOptedIn: null,
    dateFormat : 'DATE FORMAT GET FROM BROWSER/SETTINGS',
    IsWriteIntech: false,
    accountTypeId: null,
    isProduction: false,
    nativeAccountTypeId: null,
    allowAnalytics: null,
    isTempPassword: false,
    passwordResetCode: null,
    idleTimeout: 3600000, // Default to 1 hour
    loginTypeId: null,

    setIdleTimeout(timeout) {
        this.idleTimeout = timeout;
    },

    setPreferedLeakDetection(value) {
        this.PreferedLeakDetection = value
    },

    // So I know this is redundant, but I want to get the point across that this doesn't reload
    setInstanceNoLoad(instanceId) {
        this.setInstanceId(instanceId);
    },

    setIsProduction(data) {
        this.isProduction = data;
    },

    setFullPayload(data) {
        this.fullPayload = data;
    },

    setState(name) {
        this.state = name
    },

    setUserCulture(culture) {
        this.culture = culture;
    },

    setLbsOnlyDecimal(state) {
        this.onlyLbsDecimal = state === 1;
    },

    setWeightUnits(weightUnits) {
        this.weightUnits = weightUnits;
    },

    setUserName(name) {
        this.userName = name;
    },

    setUserId(id) {
        this.userId = id;
    },

    setInstanceName(name) {
        this.instanceName = name;
    },

    setInstanceId(id) {
        this.instanceId = id;
    },

    setNativeInstanceId(id) {
        this.nativeInstanceId = id;
    },

    setInstances(instances) {
        this.instances = instances;
    },

    setLocations(locations) {
        this.locations = locations
    },

    setFirstName(name) {
        this.firstName = name;
    },

    setLastName(name) {
        this.lastName = name;
    },

    setGroupId(groupId) {
        this.groupId = groupId;
    },

    setIsOptedIn(optedIn) {
        this.isOptedIn = optedIn;
    },

    setIsWriteIntech(value) {
        this.IsWriteIntech = value
    },

    setRoles(value) {
        this.roles = value
    },

    setNativeAccountTypeId(value) {
        this.nativeAccountTypeId = value;
    },

    setAccountType(value) {
        this.accountTypeId = value
    },

    setAllowAnalytics(value) {
        this.allowAnalytics = value;
    },

    setIsTempPassword(value) {
        this.isTempPassword = value;
    },
    setPasswordResetCode(value) {
        this.passwordResetCode = value;
    },

    setLoginTypeId(id) {
        this.loginTypeId = id;
    },

    getInstance(id) {
        return this.instances.find(i => i.id === id);
    },

    getInstanceID(){
        return this.instanceId;
    },

    getUserDateFormat() {
        return this.dateFormat
    },

    getIsOptedIn() {
        return this.isOptedIn;
    },

    getWeightUnits() {
        return this.weightUnits;
    },

    getCulture() {
        return this.culture;
    },

    getLoginTypeId() {
        return this.loginTypeId;
    },

    reset() {
        this.userName = null;
        this.userId = null;
        this.instanceName = null;
        this.instanceId = null;
        this.firstName = null;
        this.lastName = null;
        this.instances = [];
        this.locations = [];
        this.groupId = null;
        this.isOptedIn = null;
    },
    canServiceInstance(instanceId) {
        return this.instances.some(i => i.id === instanceId);   
    },
    canManageLocations() {
        return this.isSystemAdministrator() ||
            this.isTenantAdministrator() ||
            this.isSuperTenantAdmin() ||
            this.isRegionalAdministrator() ||
            this.isRoleExist(AppRoles.Manage_Locations);
    },
    canServiceLocation(locationId, instanceId) {
        var instance = this.instances.find(i => i.id === instanceId);

        
        if (!instance || (!instance.canManageLocations && !this.canManageLocations())) {
            //User has no access to instance or just plain old can't manage locations
            return false;
        }

        if (instance.restrictedLocations || this.isRegionalAdministrator()) {
            if (this.locations.find(l => l.locationId === locationId)) {
                //Location is editable
                return true;
            } else {
                return false;
            }
        }

        //This means instance is assigned to user, has canManageLocations == true, and restrictedLocations == false
        return true;
    },
    isSystemAdministrator() { return this.groupId === Enums.UserTypes.SystemAdministrator; },
    isTenantAdministrator() { return this.groupId === Enums.UserTypes.TenantAdministrator; },
    isNativeTenantAdministrator() {
        return (
            this.groupId === Enums.UserTypes.TenantAdministrator
            && this.instanceId === this.nativeInstanceId
        );
    },
    isRegionalAdministrator() { return this.groupId === Enums.UserTypes.RegionalAdministrator; },
    isNativeRegionalAdministrator() {
        return (
            this.groupId === Enums.UserTypes.RegionalAdministrator
            && this.instanceId === this.nativeInstanceId
        );
    },
    isPurchasingAdministrator() { return this.groupId === Enums.UserTypes.PurchasingAdministrator; },
    isSustainabilityManager() { return this.groupId === Enums.UserTypes.SustainabilityManager; },
    isSubstationAdministrator() { return this.groupId === Enums.UserTypes.SubstationAdministrator; },
    isTechnician() { return this.groupId === Enums.UserTypes.Technician; },
    isReadOnly() { return this.groupId === Enums.UserTypes.ReadOnly; },
    isTechnicianManager() { return this.groupId === Enums.UserTypes.TechnicianManager; },
    isNativeTechnicianManager() {
        return (
            this.groupId === Enums.UserTypes.TechnicianManager
            && this.instanceId === this.nativeInstanceId
        );
    },
    isInformational() { return this.groupId === Enums.UserTypes.Informational; },
    isReclaimAccounting() { return this.groupId === Enums.UserTypes.ReclaimAccounting; },
    isReclaimCSR() { return this.groupId === Enums.UserTypes.ReclaimCSR; },
    isReclaimLab() { return this.groupId === Enums.UserTypes.ReclaimLab; },
    isReclaimReadOnly() { return this.groupId === Enums.UserTypes.ReclaimReadOnly; },
    isReclaimAssociationManager() { return this.groupId === Enums.UserTypes.ReclaimAssociationManager; },
    isLocationManager() { return this.groupId === Enums.UserTypes.LocationManager; },
    isWholesaler() { return this.groupId === Enums.UserTypes.Wholesaler; },
    isReclaimShipping() { return this.groupId === Enums.UserTypes.ReclaimShipping; },
    isReclaimNeutronics() { return this.groupId === Enums.UserTypes.ReclaimNeutronics; },
    isReclaimGasTech() { return this.groupId === Enums.UserTypes.ReclaimGasTech; },
    isReclaimAdministrator() { return this.groupId === Enums.UserTypes.ReclaimAdministrator; },
    isSuperTenantAdmin() { return this.groupId === Enums.UserTypes.SuperTenantAdmin; },
    isNativeSuperTenantAdministrator() {
        return (
            this.groupId === Enums.UserTypes.SuperTenantAdmin
            && this.instanceId === this.nativeInstanceId
        );
    },
    isWorkOrderNumberRequired() {
        return this.instances.filter((obj) => obj.id == this.instanceId)[0].isWorkOrderNumberRequired
    },
    isAdminRole() {
        return (
            this.isSystemAdministrator()
            || this.isSuperTenantAdmin()
            || this.isTenantAdministrator()
        );
    },
    isNativeAdminRole() {
        return (
            this.isSystemAdministrator()
            || this.isNativeSuperTenantAdministrator()
            || this.isNativeTenantAdministrator()
        );
    },
    isNativeUser() {
        return this.instanceId === this.nativeInstanceId
    },
    isServiceProvider() {
        return this.accountTypeId === Enums.AccountTypes.ContractorLite;
    },

    isServiceProviderAndisNativeUser() {
        return !UserInfo.isSystemAdministrator() && UserInfo.isServiceProvider() && UserInfo.isNativeUser()
    },
    isServiceProviderAndisNotNativeUser() {
        return !UserInfo.isSystemAdministrator() && UserInfo.isServiceProvider() && !UserInfo.isNativeUser()
    },
    isRoleExist(role) {
        return this.roles.includes(role);
    },
    isSystemOwner() {
        return this.accountTypeId === Enums.AccountTypes.Tenant
    },
    isNativeSystemOwner() {
        return this.instanceId === this.nativeInstanceId && this.accountTypeId === Enums.AccountTypes.Tenant;
    },
    isNativeServiceProvider() {
        return this.instanceId === this.nativeInstanceId && this.accountTypeId === Enums.AccountTypes.ContractorLite;
    },
    // Check if the user is originally a ServiceProvider
    isNativeAccountServiceProvider() {
        return this.nativeAccountTypeId === Enums.AccountTypes.ContractorLite;
    },
}

export default UserInfo;
